<form [formGroup]="formTable" class="style-form-default" (ngSubmit)="addData()">
  <div
    class="style-input-default"
    data-text="N° de pasaporte *"
    [ngClass]="{ error: verificateInput('pasaporte') }"
  >
    <input
      type="text"
      placeholder="N° de pasaporte"
      formControlName="pasaporte"
    />
    <mat-error *ngIf="formTable.get('pasaporte').hasError('pattern')"
      >El N° de pasaporte es <strong>invalido</strong></mat-error
    >
  </div>

  <div
    class="style-input-default"
    data-text="Tipo de movimiento *"
    [ngClass]="{ error: verificateInput('tipo_movimiento') }"
  >
    <input
      type="text"
      placeholder="Tipo de movimiento"
      formControlName="tipo_movimiento"
    />
  </div>
  <div
    class="style-input-default"
    data-text="Aerolinea *"
    [ngClass]="{ error: verificateInput('aerolinea') }"
  >
    <input type="text" placeholder="Aerolinea" formControlName="aerolinea" />
  </div>
  <div
    class="style-input-default"
    data-text="Tipo de visa *"
    [ngClass]="{ error: verificateInput('tipo_visa') }"
  >
    <input type="text" placeholder="Tipo de visa" formControlName="tipo_visa" />
  </div>
  <div
    class="style-input-default"
    data-text="Sello *"
    [ngClass]="{ error: verificateInput('sello') }"
  >
    <input type="text" placeholder="Sello" formControlName="sello" />
  </div>
  <div
    class="style-input-default"
    data-text="Fecha trámite *"
    [ngClass]="{ error: verificateInput('fecha_tramite') }"
  >
    <input type="date" formControlName="fecha_tramite" />
  </div>
  <div
    class="style-input-default"
    data-text="País - Ciudad de origen *"
    [ngClass]="{ error: verificateInput('pais_ciudad_origen') }"
  >
    <input
      type="text"
      placeholder="País - Ciudad de origen"
      formControlName="pais_ciudad_origen"
    />
  </div>
  <div
    class="style-input-default"
    data-text="N° de vuelo *"
    [ngClass]="{ error: verificateInput('numero_vuelo') }"
  >
    <input
      onlyNumber
      type="text"
      placeholder="N° de vuelo"
      formControlName="numero_vuelo"
    />
    <mat-error *ngIf="formTable.get('numero_vuelo').hasError('pattern')"
      >El N° de vuelo es <strong>invalido</strong></mat-error
    >
  </div>
  <div
    class="style-input-default"
    data-text="País - Ciudad de destino *"
    [ngClass]="{ error: verificateInput('pais_ciudad_destino') }"
  >
    <input
      type="text"
      placeholder="País - Ciudad de destino"
      formControlName="pais_ciudad_destino"
    />
  </div>
  <button
    type="submit"
    *ngIf="!status"
    [disabled]="formTable.invalid || submit"
  >
    <i class="fas fa-plus"></i>
  </button>
</form>

<div class="task_content_table example">
  <table mat-table #dataTable [dataSource]="dataSource" class="task_table">
    <ng-container matColumnDef="pasaporte">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Pasaporte
      </th>
      <td mat-cell *matCellDef="let element">{{ element.pasaporte }}</td>
    </ng-container>

    <ng-container matColumnDef="tipo_movimiento">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Movimiento
      </th>
      <td mat-cell *matCellDef="let element">{{ element.tipo_movimiento }}</td>
    </ng-container>

    <ng-container matColumnDef="aerolinea">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Aerolinea
      </th>
      <td mat-cell *matCellDef="let element">{{ element.aerolinea }}</td>
    </ng-container>

    <ng-container matColumnDef="tipo_visa">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Visa</th>
      <td mat-cell *matCellDef="let element">{{ element.tipo_visa }}</td>
    </ng-container>

    <ng-container matColumnDef="sello">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Sello</th>
      <td mat-cell *matCellDef="let element">{{ element.sello }}</td>
    </ng-container>

    <ng-container matColumnDef="pais_ciudad_origen">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Origen</th>
      <td mat-cell *matCellDef="let element">
        {{ element.pais_ciudad_origen }}
      </td>
    </ng-container>

    <ng-container matColumnDef="numero_vuelo">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Vuelo</th>
      <td mat-cell *matCellDef="let element">{{ element.numero_vuelo }}</td>
    </ng-container>

    <ng-container matColumnDef="fecha_tramite">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Fecha</th>
      <td mat-cell *matCellDef="let element">{{ element.fecha_tramite }}</td>
    </ng-container>

    <ng-container matColumnDef="pais_ciudad_destino">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Destino</th>
      <td mat-cell *matCellDef="let element">
        {{ element.pais_ciudad_destino }}
      </td>
    </ng-container>

    <ng-container matColumnDef="opciones">
      <th class="header-options" mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="options">
          <button class="delete" (click)="removerCuenta(i)">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<mat-paginator
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [pageSize]="5"
  [showFirstLastButtons]
></mat-paginator>
